import { Component, AfterViewInit } from '@angular/core';
import { CanvasEvent } from 'src/app/events/canvas.event';
import { ApplicationService } from 'src/app/services/application.service';
import { CONFIGURATION_CONTEXT, CONFIGURATION_MODE } from 'src/app/data/configuration.data';
import { ModalService } from 'src/app/services/modal.service';
import { UserData } from 'src/app/data/user.data';
import { UserExcelData } from 'src/app/data/user/user-excel.data';
import { TranslateService } from '@ngx-translate/core';
import * as Papa from 'papaparse';
import { ConfigurationEvent } from 'src/app/events/configuration.event';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

import * as chardet from 'chardet';
import { ApplicationData } from 'src/app/data/application.data';

@Component({
  selector: 'app-configurator',
  templateUrl: './configurator.component.html',
  host: {
    'class': 'page__container configurator'
  },
})
export class ConfiguratorComponent implements AfterViewInit {

  public canvasRotation: number = 0;
  public command: CanvasEvent;

  public excelImportStep: number = -1;
  public excelProgressRef:string;
  public excelErrorRef:string;
  public step2openedBox: number = 1;
  public step2selectedFile: number = -1;
  public step2userInputs: any[];


  /**
   * Constructor
   */
  constructor(
    public applicationService:ApplicationService,
    public applicationData:ApplicationData,
    private modalService:ModalService,
    public userService:UserService,
    public userData:UserData,
    private translateService:TranslateService) {

  }

  updateRotation(rotation:number){
    // Pour palier à un NgAfterCheck violation...
    setTimeout(()=>{
      this.canvasRotation = rotation;
    })
  }

  /**
   * On init
   */
  ngAfterViewInit(): void {

    if(this.applicationData.configuration.context == CONFIGURATION_CONTEXT.NEW && !this.applicationData.configuration.multiFormat){
      // EXCEL MODAL
      setTimeout(()=>{
        this.excelImportStep = 1;
        this.excelProgressRef = '';
        this.excelErrorRef = '';
        this.modalService.open('modal-excel', {});
      },1000)
    }
  }

  /**
   * onCommand
   */
  onCommand(event: CanvasEvent): void {
    this.command = event;
  }

  clickExcelAdvice(){

  }

  selectExcelMode(){

    // this.hackForDev(); return;

    if(this.userData.id > 0){
      this.initExcelMode();
    } else {
      this.userService.invokeLogin().then(()=>{
        this.initExcelMode();
      },(error)=>{
        // Do nothing
      });
    }

  }

  hackForDev2(){
    this.initExcelMode();
  }

  hackForDev(){

    let _xlsxF = new UserExcelData(0,'CSV hackForDev', environment.USER_CSV_FOLDER+"1_2012-hrm-database_2012-02-21-12-10-00.csv")
    this.processExcelFile(_xlsxF);

  }

  initExcelMode(){
    this.excelImportStep = 2 ;
    this.step2selectedFile = -1 ;
    this.resetUserInputs();
  }

  resetUserInputs(){
    this.step2userInputs = [
      {value:this.translateService.instant('cfg_import_defaultField1')},
      {value:this.translateService.instant('cfg_import_defaultField2')},
      {value:this.translateService.instant('cfg_import_defaultField3')}
    ];
  }

  addUserInputs(){
    let _counter:number = this.step2userInputs.length+1;
    this.step2userInputs.push({value:this.translateService.instant('cfg_excel_fieldTitle') + " " +_counter});
  }

  deleteUserInputs(index:number){
    this.step2userInputs.splice(index,1);
  }

  generateEmptyCsv(){
    let csvJson = [this.step2userInputs.map(ui=>ui.value)];

    // console.log(csvJson);

    var csvFile = Papa.unparse(csvJson,{
      quotes: false, //or array of booleans
      quoteChar: '"',
      escapeChar: '"',
      delimiter: ";",
      header: true,
      newline: "\r\n",
      skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
      columns: null //or array of strings
    });

    const length = csvFile.length;
    const csvFileBytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      const code = csvFile.charCodeAt(i);
      const byte = code > 255 ? 32 : code;
      csvFileBytes[i] = byte;
    }

    let _rightNow = new Date();
    let _fileName: string = this.applicationData.configuration.sheetProperties.reference + " - " + this.translateService.instant('cfg_excel_fileName') + " " + _rightNow.toISOString().slice(0, 19).replace(/\:/g, "-").replace("T", "_")+".csv";


      var blob = new Blob([csvFileBytes.buffer as BlobPart], { type: "text/csv; charset=ISO-8859-1" });
      if ((navigator as any).msSaveBlob) { // IE 10+
          (navigator as any).msSaveBlob(blob, _fileName);
          this.excelImportStep = 3;
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", _fileName);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              this.excelImportStep = 3;
          }
      }
  }

  processExcelFile(excelFile:UserExcelData){

    // console.log("processExcelFile()");

    var request = new XMLHttpRequest();
    request.open('GET', excelFile.url, true);
    request.responseType = 'arraybuffer';
    request.onload = () => {

      const buffer = request.response as ArrayBuffer;
      const uint8Array = new Uint8Array(buffer);

      // Détecter l'encodage avec chardet
      const detected = chardet.detect(uint8Array);
      const encoding = detected || 'UTF-8';

      const decoder = new TextDecoder(encoding);
      const content = decoder.decode(uint8Array);

      Papa.parse(content, {
        skipEmptyLines:true,
        complete:(results, file)=>{
          // console.log(results);
          if(results.data.length < 2){
            this.excelProgressRef = ''
            this.excelErrorRef ='cfg_excel_error_fileEmpty';
          } else {
            this.applicationData.configuration.csv = results.data;
            this.applicationData.configuration.mode = CONFIGURATION_MODE.EXCEL;
            this.applicationData.configuration.mustControlOverlapseBeforePrint = true;
            this.modalService.cancel('modal-excel');
          }
        },
        error:(error)=>{
          console.error(error);
          this.excelProgressRef = '';
          this.excelErrorRef ='cfg_imageImportFail1';
        }
      });


    };
    request.send();
  }


  selectExcelFile(){
    // console.log("selectExcelFile()");
    this.excelProgressRef = 'cfg_excel_downloadInfo';
    let excelFile:UserExcelData = this.userData.excels.find(excelF=>excelF.id === this.step2selectedFile);
    this.processExcelFile(excelFile);
  }

  browseExcelFile(){
    // console.log("browseExcelFile()");
    let tempDomElmt = document.createElement('div');
			tempDomElmt.style.display = "none";
			tempDomElmt.innerHTML = '<input id="csvBrowser" type="file" value="Parcourir" accept="text/csv" />';
			document.body.appendChild(tempDomElmt);


			document.getElementById("csvBrowser").onchange = (e: any) => {

        this.excelProgressRef = 'cfg_excel_downloadInfo';

				if (e.target.files && e.target.files[0]) {

          let _sameNamePreviousExcelFile:UserExcelData = this.userData.excels.find(excelF=>excelF.name === e.target.files[0].name);

          let _mimesOk:string[] = [
            "", // Edge when Excel not installed :')
            "text/plain",
            "application/vnd.ms-excel",
            "text/x-csv",
            "application/csv",
            "application/x-csv",
            "text/csv",
            "text/comma-separated-values",
            "text/x-comma-separated-values"
          ];

          let _fileExtension:string = e.target.files[0].name.split(".").pop();

          // console.log("browseExcelFile() onchange", e.target.files[0], _fileExtension);

          if (_sameNamePreviousExcelFile) {
            this.excelProgressRef = '';
            this.excelErrorRef ='cfg_excel_error_fileExist';
          } else if (_fileExtension != "csv") {
            this.excelProgressRef = '';
            this.excelErrorRef ='cfg_imageImportFail1';
          } else if (_mimesOk.indexOf(e.target.files[0].type) < 0) {
            this.excelProgressRef = '';
            this.excelErrorRef ='cfg_imageImportFail1';
          } else {
              this.userService.uploadCsv(e.target.files[0]).then((ued:UserExcelData)=>{
                this.userData.excels.push(ued);
                this.processExcelFile(ued);
              }, (error)=>{
                this.excelProgressRef = ''
                this.excelErrorRef = error;
              });
          }



				} else {
					//reject("L'utilisateur a annulé l'import.");
				}
			};


			document.getElementById("csvBrowser").click();
  }

  closeError(){

  }

}
